/**
 * Van Gurp — Main application entry point
 *
 * jQuery is available globally via OctoberCMS (@jquery in partials).
 * Do NOT import it here — use window.$ or window.jQuery if needed.
 */

// --- Modules (auto-init on import) ---
import './modules/off-canvas.js';
import './modules/drilldown.js';
import './modules/modal.js';
import './modules/sticky-header.js';
import './modules/custom-select.js';

// --- Components (explicit init) ---
import { initForms } from './components/form.js';
import { initValidation } from './components/validation.js';
import { initAccordion } from './components/accordion.js';
import { initFaq } from './components/faq.js';
import { initScrollAnimations } from './components/scroll-animations.js';

document.addEventListener('DOMContentLoaded', () => {
  initForms();
  initValidation();
  initAccordion();
  initFaq();
  initScrollAnimations();

  // --- Lazy-loaded carousels (only when needed) ---
  const smallCarousels = document.querySelectorAll('.small-carousel');
  if (smallCarousels.length) {
    import('./modules/carousel.js').then((m) => m.init(smallCarousels));
  }

  if (document.querySelector('[data-quote-carousel]')) {
    import('./components/quote-carousel.js').then(m => m.initQuoteCarousel());
  }
});

// --- Consent cookie ---
document.querySelectorAll('.ConsentCookieShow').forEach(el => {
  el.setAttribute('data-cc', 'show-preferencesModal');
});

// --- Off-canvas hamburger toggle ---
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-toggle="off-canvas"], [data-off-canvas-toggle]');
  if (!trigger) return;

  const hamburger = document.querySelector('.hamburger');
  if (hamburger) {
    const panel = document.querySelector('.off-canvas, #offCanvas');
    if (panel && panel.classList.contains('is-open')) {
      hamburger.classList.remove('is-active');
    } else {
      hamburger.classList.add('is-active');
    }
  }
});
